export default __webpack_public_path__ + "static/hero-bg-min-1x-fda628e5c6b8b2abaee118c3272454e2.webp";